import { StoreService } from '../shared/services/store-service.service';
import { SelectItem } from 'primeng/api';
import { SliderBannerStatus } from '../shared/models/slider-banner-status';
import { SliderBannerProductService } from '../shared/services/slider-banner-product.service';
import { SliderBannerModel } from '../shared/models/slider-banner-model';
import { StoreItemModel } from '../shared/models/store-item-model';
import { SliderBannerRequestFilterModel } from '../shared/models/slider-banner-request-filter-model';
import { Component, OnInit } from '@angular/core';
import { PagingFilter } from '@admin/shared/models/paging-filter.model';
import { LazyLoadEvent } from 'primeng/api';
import { LookupService } from '@admin/shared/services/lookup.service';
import { ConfigurationService } from '@admin/shared/services/configuration.service';
import { ProductType } from '@admin/product-purchases/shared/models/product-type';
import { UserService } from '../../core/user.service';
import { FeatureEnum } from '../../shared/models/feature-enum';
import { Table } from 'primeng/table';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-slider-banner-product-request-list',
  templateUrl: './slider-banner-product-request-list.component.html',
  styleUrls: ['./slider-banner-product-request-list.component.less'],
  standalone: false,
})
export class SliderBannerProductRequestListComponent implements OnInit {
  public filterPagingWrapper: PagingFilter<SliderBannerRequestFilterModel>;
  public storeItems: StoreItemModel[];

  public sliderBannerRequestList: SliderBannerModel[];

  public totalRecords: number;

  public lastLoadEvent: LazyLoadEvent;

  public dateFormat: string;
  public specialDateFormat: string;
  public pageSize: number;

  public hasRequestApproveRejectPermission: boolean;
  public hasRequestTerminationPermission: boolean;

  private isReset: boolean;

  public switchFilterState: SwitchFilterState;

  public switchFilterStates: SelectItem[];

  public sliderBannerRequestStatus: any;

  onLoad(event: LazyLoadEvent) {
    if (this.isReset) {
      this.sliderBannerRequestList = [];
      this.totalRecords = 0;
      return;
    }

    this.filterPagingWrapper.pagingInfo.start = event.first;
    this.filterPagingWrapper.pagingInfo.limit = event.rows;
    this.lastLoadEvent = event;
    let filters: { [index: string]: any } = [];

    if (event.filters != null) {
      for (let f in event.filters) {
        {
          filters[f] = event.filters[f].value;
        }
      }
    }

    if (event.sortField && event.sortOrder) {
      this.filterPagingWrapper.sortParameters = [
        {
          column: event.sortField,
          order: event.sortOrder == 1 ? 'asc' : 'desc',
        },
      ];
    }

    this.filterPagingWrapper.filter.customerName = filters['fullName'];
    this.onFilter();
  }

  onFilter() {
    this.filterPagingWrapper.pagingInfo.start =
      this.filterPagingWrapper.pagingInfo.start || 0;

    this.filterPagingWrapper.filter.statusIds = [];

    const statusIds = this.getSwitchStateRelevantStatuses();

    this.filterPagingWrapper.filter.statusIds = statusIds;

    this.sliderBannerProductService
      .listSliderBannerRequests(this.filterPagingWrapper)
      .subscribe((resp) => {
        this.totalRecords = resp.totalCount;
        this.sliderBannerRequestList = resp.items;
      });
  }

  getSwitchStateRelevantStatuses() {
    const statusIds = [];

    switch (this.switchFilterState) {
      case SwitchFilterState.Pending: {
        statusIds.push(...[SliderBannerStatus.Pending]);
        break;
      }
      case SwitchFilterState.Active: {
        statusIds.push(...[SliderBannerStatus.Active]);
        break;
      }
      case SwitchFilterState.Expired: {
        statusIds.push(...[SliderBannerStatus.Expired]);
        break;
      }
      case SwitchFilterState.Rejected: {
        statusIds.push(...[SliderBannerStatus.Rejected]);
        break;
      }
      case SwitchFilterState.Terminated: {
        statusIds.push(...[SliderBannerStatus.Terminated]);
        break;
      }
    }

    return statusIds;
  }

  // TODO: on select button change
  onSwitchFilterClick(dt: Table, newState: SwitchFilterState) {
    // this.filterPagingWrapper.filter.drivingLicenses = this.selectedDrivingLicenses.map(p => p.value);
    // this.filterPagingWrapper.filter.locations = this.selectedLocations.map(p => p.value);

    // set statusIds

    this.switchFilterState = newState;

    this.filterPagingWrapper.pagingInfo.start = 0;

    // TODO: bug in paginator, does not update state correctly, change this code after bug is fixed in framework (primeng)
    this.isReset = true;
    dt.reset();
    this.isReset = false;

    this.onFilter();
  }

  // getSpecialDateFormat(format: string){
  //     return format.replace('MM', 'mm').replace('yyyy', 'yy');
  // }

  onApproveRequestClick(item: SliderBannerModel) {
    if (!confirm(this.translateService.instant('message.AreYouSure'))) {
      return;
    }

    if (item.storeItemId !== item.storeItem.itemId) {
      this.sliderBannerProductService
        .approveSliderBannerRequestWithModification(item, item.storeItemId)
        .subscribe((resp) => {
          this.onFilter();
        });
    } else {
      this.sliderBannerProductService
        .approveSliderBannerRequest(item)
        .subscribe((resp) => {
          this.onFilter();
        });
    }
  }

  onRejectRequestClick(item: SliderBannerModel) {
    if (!confirm(this.translateService.instant('message.AreYouSure'))) {
      return;
    }
    this.sliderBannerProductService
      .rejectSliderBannerRequest(item)
      .subscribe((resp) => {
        this.onFilter();
      });
  }

  onRevokeRequestClick(result: any) {
    if (!result.agree) {
      return;
    }
    this.sliderBannerProductService
      .revokeSliderBannerRequest(result.id, result.checked)
      .subscribe((resp) => {
        this.onFilter();
      });
  }

  constructor(
    private lookupService: LookupService,
    private config: ConfigurationService,
    private sliderBannerProductService: SliderBannerProductService,
    private userService: UserService,
    private storeService: StoreService,
    private translateService: TranslateService
  ) {
    this.hasRequestApproveRejectPermission = false;
    this.hasRequestTerminationPermission = false;

    this.filterPagingWrapper = new PagingFilter(
      new SliderBannerRequestFilterModel()
    );
    this.sliderBannerRequestStatus = SliderBannerStatus;
    this.sliderBannerRequestList = [];
    this.switchFilterStates = [
      {
        label: this.translateService.instant('label.Pending'),
        value: SwitchFilterState.Pending,
      },
      {
        label: this.translateService.instant('label.Active'),
        value: SwitchFilterState.Active,
      },
      {
        label: this.translateService.instant('label.Expired'),
        value: SwitchFilterState.Expired,
      },
      {
        label: this.translateService.instant('label.Rejected'),
        value: SwitchFilterState.Rejected,
      },
      {
        label: this.translateService.instant('label.Terminated'),
        value: SwitchFilterState.Terminated,
      },
    ];
    this.switchFilterState = SwitchFilterState.Pending;
  }

  ngOnInit() {
    // let lookupData = this.lookupService.getCachedLookupData();

    const config = this.config.getCachedConfig();

    this.dateFormat = config.dateFormat; // TODO get from config
    // this.specialDateFormat = this.getSpecialDateFormat(this.dateFormat);
    this.pageSize = config.defaultPageSize; // TODO get from config

    const userFeatures = this.userService.currentUser.features;
    this.hasRequestApproveRejectPermission = userFeatures.some(
      (f) => f === FeatureEnum.ApproveRejectSliderBannerProductRequest
    );
    this.hasRequestTerminationPermission = userFeatures.some(
      (f) => f === FeatureEnum.TerminateActiveSliderBannerProduct
    );

    this.switchFilterState = SwitchFilterState.Pending;

    this.storeService
      .listStockItems(ProductType.SliderBanner)
      .subscribe((resp) => {
        this.storeItems = resp.items;
      });
  }
}

enum SwitchFilterState {
  Pending = 1,
  Active = 2,
  Expired = 3,
  Rejected = 4,
  Terminated = 5,
}
